import { gql } from '@/__generated__';
import BlockHeader from '@/components/BlockHeader';
import SkeletonCards from '@/components/SkeletonCards';
import Box from '@/components/ui/Box';
import Btn from '@/components/ui/Btn';
import Grid from '@/components/ui/Grid';
import { GENRE_CATEGORY_FRAGMENT } from '@/gql/fragments/categories.gql';
import { useCategory } from '@/lib/getters/useCategory';
import useCommonLinks from '@/lib/getters/useCommonLinks';
import { createBlock } from '@/lib/parsers/blocks';
import { createFragmentParser } from '@liquorice/gql-utils';
import { BlockContainer } from '../..';

export const EVENT_TYPE_BLOCK_FRAGMENT = gql(`
  fragment categoryTypeBlock on blocks_categoryType_BlockType {
    heading
  }
`);

export const CategoryTypeBlock = createBlock(EVENT_TYPE_BLOCK_FRAGMENT, ({ data, meta }) => {
  const { heading } = data;
  const category = useCategory({ group: 'genreCategory' });
  const loading = category?.loading;

  const { eventIndex } = useCommonLinks();
  const eventIndexUri = eventIndex.uri;

  const categoryParser = createFragmentParser(GENRE_CATEGORY_FRAGMENT, (data) => data);
  const items = category?.result.map((item) => {
    if (item.__typename === 'genreCategory_Category') return categoryParser(item);
  });

  return (
    <BlockContainer
      {...{
        colorSet: 'cream',
        paper: true,
        meta,
        marginY: 'none',
        paddingY: true,
        overflow: true,
        customAnchor: heading,
      }}>
      <BlockHeader
        maxWidth="none"
        heading={heading}
        HeadingProps={{ variant: 'h2', cx: { mB: '3xl' }, uppercase: true, autoMargin: false }}
      />
      {loading ? (
        <SkeletonCards
          amount={12}
          xs={4}
          md={2}
          SkeletonItems={{
            bgcolor: 'white',
            items: [
              { variant: 'rounded', height: 10 },
              { variant: 'rounded', height: 25 },
            ],
          }}
        />
      ) : (
        <Grid cx={{ columnGap: 'md', rowGap: 'md' }}>
          {items?.map((item, i) => {
            return (
              item && (
                <Grid.Col key={i} xs={4} md={2}>
                  <Box cx={{ width: '50', bgcolor: 'black' }} style={{ height: 10 }} />
                  <Btn
                    key={item.id}
                    href={`${eventIndexUri}?genreCategory=${item.id}`}
                    color="black"
                    uppercase
                    fontFamily="heading"
                    wrap
                    variant="text">
                    {item.title}
                  </Btn>
                </Grid.Col>
              )
            );
          })}
        </Grid>
      )}
    </BlockContainer>
  );
});

export default CategoryTypeBlock;
